import { Button } from "@/components/ui/button";
import { Wheat } from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.role !== "pending") navigate("/dashboard", { replace: true });
    else if (user && user.role === "pending") navigate("/role-select", { replace: true });
  }, [user, navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="bg-white border border-stone-200 rounded-md p-10 sm:p-14 max-w-md w-full">
        <div className="flex justify-center">
          <span className="w-14 h-14 rounded-full bg-emerald-800 flex items-center justify-center">
            <Wheat className="text-stone-50" />
          </span>
        </div>
        <h1 className="mt-8 font-serif text-3xl text-stone-900 text-center">Welcome to Azure Gypsy Farms</h1>
        <p className="mt-3 text-center text-sm text-stone-600 font-sans">
          Sign in with Google to join as a hobby farmer, driver, client, or wholesale buyer.
        </p>
        <Button
          data-testid="google-signin-btn"
          onClick={signIn}
          className="mt-8 w-full bg-emerald-800 hover:bg-emerald-700 text-stone-50 py-6 rounded-md"
        >
          Continue with Google
        </Button>
        <p className="mt-6 text-center text-[11px] uppercase tracking-[0.2em] text-stone-500">
          Secure · Verified · Local-first
        </p>
      </div>
    </div>
  );
}
